import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BaseService } from './default/base.service';

@Injectable({
  providedIn: 'root'
})
export class GavePermissionService extends BaseService {

  constructor( http: HttpClient) {
    super(http);
  }

  verifyUserGavePermission() {
    return this.http.get(`${this.urlApi}/wirecard/gave-permission`).toPromise();
  }

  getUrlPermission() {
    return this.http.get(`${this.urlApi}/wirecard/url-permission`).toPromise();
  }
}
